import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import React from "react";

import App from "./containers/App";

//Redux Smart
import TourPage from "./containers/TourPage";
import ArchiveTourPage from "./containers/ArchiveTourPage";
import Tours from "./components/Tours";
import MapPage from "./containers/MapPage";
import ContactsPage from "./containers/ContactsPage";
import Page from "./components/Page";
import Destination from "./components/Destination";
import Destinations from "./components/Destinations";
import Collection from "./components/Collection";
import Landmark from "./components/Landmark";
import Landmarks from "./components/Landmarks";
//import Hotels from "./components/Hotels";
import Hotel from "./components/Hotel";
import OrderPage from "./containers/OrderPage";
import Navigation from "./components/Navigation";
import ReviewsPage from "./containers/ReviewsPage";
import Account from "./components/Account";
import PromoHB from "./components/PromoHB";
import CustomTour from "./components/CustomTour";

//Redux Dumb
import AboutPage from "./components/About";
import error404 from "./components/404";  
import ActiveTours from "./components/type/Active";
import CruiseTours from "./components/type/Cruise";
import DiscoveryTours from "./components/type/Discovery";
import ExpeditionTours from "./components/type/Expedition";
import FamilyTours from "./components/type/Family";
import YourTours from "./components/type/Your";
import PureTours from "./components/type/Pure";

export default (
  <Route name="app" path="/" component={App}>
    <Route path="home" component={Tours} />
    <Route path="/map" component={MapPage} />
    <Route path="/contacts" component={ContactsPage} />
    <Route path="/reviews" component={ReviewsPage} />
    <Route name="navigation" path="/tours" component={Navigation} />
    <Route name="about" path="about" component={AboutPage} />
    <Route path="/tour/:param_id/order" component={OrderPage} />
    <Route path="/order/:order_id" component={OrderPage} />
    <Route path="/tours/:param_id" component={TourPage} />
    <Route path="/tours/archive" component={Navigation} />
    <Route path="/tours/archive/:param_id" component={ArchiveTourPage} />
    <Route path="/destinations" component={Destinations} />
    <Route path="/destinations/:param_id" component={Destination} />
    <Route path="/info/landmarks/:param_id" component={Landmark} />
      <Route path="/info/landmarks" component={Landmarks} />
      <Route path="/info/landmarks/page/:param_id" component={Landmarks} />
    <Route path="/hotels/:param_id" component={Hotel} />
    <Route path="/404" component={error404}/>
    <Route path="/account" component={Account}/>
      
      <Route path="/type/active" component={ActiveTours} />
      <Route path="/type/cruise" component={CruiseTours} />
      <Route path="/type/expedition" component={ExpeditionTours} />
      <Route path="/type/discovery" component={DiscoveryTours} />
      <Route path="/type/family" component={FamilyTours} />
      <Route path="/type/your" component={YourTours} />
      <Route path="/type/pure" component={PureTours} />
      <Route path="/promo/10years" component={PromoHB} />
      <Route path="/promo/:param_id" component={Collection} />
      <Route path="/custom-tour" component={CustomTour} />
      <Route name="page" path="/:param_id" component={Page} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/common/routes.js